export default "__VITE_ASSET__BdNWMoaO__"